import React from 'react'
import _ from 'lodash'

import StringManipulator from 'Utilities/StringManipulator'

import { Button, DetailList } from 'camino-react'

const SurveyModalContent = ({ surveyResponse }) => {
  const formattedAnswer = (answer) => {
    return answer === "" ? 'No answer given' : StringManipulator.simpleFormat(answer)
  }

  return (
    <div className='popup-table-description'>
      <h2>Survey Responses</h2>
      <DetailList
        list={_.map(surveyResponse, (answer, question) => ({
            title: question,
            content: formattedAnswer(answer)
          }))
        }
      />
    </div>
  )
}

export default SurveyModalContent
